import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsParcelsService} from '../../../services/settings-parcels.service';
import {DragulaService} from 'ng2-dragula';
import {UrlService} from '../../../services/url.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'courier-type-modal',
    templateUrl: './courier-type-modal.component.html',
    styleUrls: ['./courier-type-modal.component.scss']
})
export class CourierTypeModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    courierTypes = [];
    newCourierType = '';
    somethingWasMoved = false;
    somethingWasChanged = false;

    constructor(
        public api: ApiClientService,
        public settingsParcelsService: SettingsParcelsService,
        private dragulaService: DragulaService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        this.dragulaService.drop.subscribe((value) => {
            this.somethingWasMoved = true;
        });
        this.urlService.modalOpened.emit();
    }

    initData() {
        if(this.settingsParcelsService.selectedItemData.parcelPostServices.length > 0) {
            this.courierTypes = this.settingsParcelsService.selectedItemData.parcelPostServices.map(type => ({
                id: type.id,
                name: type.name,
                editMode: false
            }));
        }
    }

    hideModal() {
        if (this.somethingWasChanged || this.somethingWasMoved) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsParcelsService.isCouriersModalShow = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsParcelsService.isCouriersModalShow = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            toastr.warning('All fields must be filled to submit fees');
            return;
        }

        this.disabledSubmit = true;

        const courierIds = this.courierTypes.map(type => (type.id));

        const data = { parcelPostServiceSorting: courierIds };

        const url = `/v1/post-services-sort/${this.settingsParcelsService.selectedItemData.corporationNumberBd}.json`;
        this.settingsParcelsService.api.patch('domainParcels', url, data).subscribe(
            () => {
                this.somethingWasMoved = false;
                this.somethingWasChanged = false;
                this.updateView('Settings were successfully updated');
            },
            error => {
                this.api.errorHandler(error, 'Update failed!');
                this.disabledSubmit = false;
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsParcelsService.selectedItemData.parcelPostServices = JSON.parse(JSON.stringify(this.courierTypes.map(t => ({
            id: t.id,
            name: t.name
        }))));
        this.form.reset();
        this.hideModal();
    }

    addCourierType() {
        if(this.newCourierType && !this.disabledSubmit) {
            const data = {
                parcelServiceSettings: this.settingsParcelsService.selectedItemData.corporationNumberBd,
                name: this.newCourierType
            };

            const url = `/v1/post-service.json`;
            this.settingsParcelsService.api.post('domainParcels', url, data).subscribe(
                res => {
                    this.courierTypes.push({
                        id: res.id,
                        name: res.name,
                        editMode: false
                    });
                    this.settingsParcelsService.selectedItemData.parcelPostServices = JSON.parse(JSON.stringify(this.courierTypes.map(t => ({
                        id: t.id,
                        name: t.name
                    }))));
                    this.newCourierType = '';
                    toastr.success('Courier type has successfully been added');
                },
                error => {
                    this.api.errorHandler(error, 'Failed to add courier type!');
                    this.disabledSubmit = false;
                }
            );
        }
    }

    turnEditModeOn(index) {
        this.courierTypes[index].editMode = true;
        setTimeout(() => document.getElementById('courierType' + index).focus(), 300);
    }

    removeCourierType(index) {
        if(!this.disabledSubmit) {
            swal(ConstantsService.getSwalConfig('Are you sure?', `Are you sure that you want to remove  ${this.courierTypes[index].name} from the list?`),
                () => {
                    this.disabledSubmit = true;
                    const url = `/v1/post-service/${this.courierTypes[index].id}.json`;
                    this.settingsParcelsService.api.remove('domainParcels', url).subscribe(
                        res => {
                            toastr.success('Courier type has been deleted successfully.');
                            this.courierTypes.splice(index, 1);
                            this.disabledSubmit = false;
                        },
                        error => {
                            this.api.errorHandler(error, 'Failed to delete courier type.');
                            this.disabledSubmit = false;
                        }
                    );
                }
            );
        }
    }

    trackByFn(index, item) {
        return index; // or item.id
    }

    modifyName(index) {
        if(!this.disabledSubmit) {
            this.disabledSubmit = true;
            const url = `/v1/post-service/${this.courierTypes[index].id}.json`;
            const data = {name: this.courierTypes[index].name};
            this.settingsParcelsService.api.patch('domainParcels', url, data).subscribe(
                res => {
                    toastr.success('The name has been updated successfully.');
                    this.courierTypes[index].editMode = false;
                    this.disabledSubmit = false;
                },
                error => {
                    this.api.errorHandler(error, 'Failed to update name.');
                    this.disabledSubmit = false;
                }
            );
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/courier-type-modal/courier-type-modal.component.ts